module.exports = __webpack_public_path__ + "img/F75701D3.982fb11c.png";